export default "/fcbcac1db17390110677298f9d30eeed9c121039/a2cdf02300b2663230f496dbfe02b4a0.svg";